/**
 * @description Makes an HTML table responsive
 * @example <table flex-grid></table>
 */
;(function () {
  'use strict'

  angular
    .module('contrast.flex-grid')
    .directive('flexGrid', function ($, $window) {
      'ngInject'

      return {
        restrict: 'A',
        link: function (scope, angularElement) {
          var element = angularElement[0],
            tableHead = $(element).find('thead'),
            tableAnchor = $(element).parents('div[flex-grid-anchor]')

          scope.columnConfigs = []
          scope.staticWidthSum = 0
          scope.flexSum = 0

          function getConfig() {
            scope.columnConfigs = []
            scope.staticWidthSum = 0
            scope.flexSum = 0

            var headers = $(tableHead).find('th')

            angular.forEach(headers, function (column) {
              column = $(column)
              if (column.attr('flex-width')) {
                var width = parseInt(column.attr('flex-width'))
                column.css('width', width + 'px')
                scope.staticWidthSum += width
              } else if (column.attr('flex')) {
                scope.flexSum += parseInt(column.attr('flex'))
              }
              scope.columnConfigs.push({
                column: column,
                width: column.attr('flex-width')
                  ? parseInt(column.attr('flex'))
                  : null,
                minWidth: column.attr('flex-min-width')
                  ? parseInt(column.attr('flex-min-width'))
                  : null,
                maxWidth: column.attr('flex-max-width')
                  ? parseInt(column.attr('flex-max-width'))
                  : null,
                flex: column.attr('flex') ? parseInt(column.attr('flex')) : null
              })
            })
          }

          function calculateWidths() {
            var tableWidth = tableAnchor[0].clientWidth,
              remaining = tableWidth - scope.staticWidthSum

            var remainingFlexConfigs = [],
              remainingFlexSum = 0,
              widthSum = scope.staticWidthSum
            angular.forEach(scope.columnConfigs, function (config) {
              if (!config.width && config.flex) {
                var width = 0
                if (remaining > 0) {
                  width = parseInt(remaining * (config.flex / scope.flexSum))
                }
                if (config.minWidth && config.minWidth > width) {
                  config.column.css('width', config.minWidth + 'px')
                  widthSum += config.minWidth
                } else {
                  remainingFlexConfigs.push(config)
                  remainingFlexSum += config.flex
                }
              }
            })

            remaining = tableWidth - widthSum
            angular.forEach(remainingFlexConfigs, function (config) {
              if (!config.width && config.flex) {
                var width = 0
                if (remaining > 0) {
                  width = Math.floor(
                    remaining * (config.flex / remainingFlexSum)
                  )
                }
                if (config.minWidth && config.minWidth > width) {
                  width = config.minWidth
                }
                config.column.css('width', width + 'px')
              }
            })
          }

          // window resize listener
          function onresize() {
            getConfig()
            calculateWidths()
          }

          // bind listeners
          $window.addEventListener('resize', onresize)

          $(element.parentElement).resize(function () {
            onresize()
          })
        }
      }
    })
})()
